import api from 'aio-api'

export default {
  namespaced: true,
  state: {
    enabled: false,
  },
  getters: {},
  actions: {
    toggle: async ({dispatch, state}) => {
      const newState = !state.enabled
      await dispatch('set', newState)
    },
    set: async ({commit}, enabled) => {
      const id = await api.company.getId()
      await api.postBetaEnabled(id, enabled)
      commit('set', enabled)
    },
    fetchEnabled: async ({commit}) => {
      const id = await api.company.getId()
      const response = await api.getBetaEnabled(id)
      commit('set', response.enabled)
    }
  },
  mutations: {
    set: (state, enabled) => state.enabled = enabled,
  },
}
